<section
  [style.min-width]="minWidth"
  #sectionRef
  id="dropdown-trigger-{{ elementId }}"
  [class]="'background-hover border-border not-plain ' + customClass"
  (keyup)="deleteLastItem($event)"
  (click)="presentPopover()"
>
  <div class="left-part" [style.max-width.px]="sectionRef.offsetWidth - 32">
    <ng-container *ngIf="value?.length > 0">
      <ion-chip
        mode="ios"
        *ngFor="let itemId of value"
        [class.readonly]="disabled"
        [class.clearable]="multiple && !disabled"
        [class.clear-chip]="!multiple"
      >
        <tr-icon
          *ngIf="multiple && !disabled"
          (click)="service.noBubble($event); checkboxChange(itemId, { checked: false })"
          [size]="iconSize.small"
          [icon]="icon.cancel"
          class="tr-icon border-hover"
        ></tr-icon>

        <div>
          <ion-label *ngIf="customName" [innerHTML]="customName(itemsIdToItemMap[itemId])"></ion-label>
          <ion-label *ngIf="!customName" [innerHTML]="itemsIdToLabelMap[itemId]"></ion-label>
        </div>
      </ion-chip>
    </ng-container>

    <div
      class="position-relative"
      [class.not-interactable]="!inputCanBeFocused"
      [class.placeholder-wrapper]="(multiple || (addTag && value?.length === 0))"
    >
      <p class="placeholder" *ngIf="searchString === '' && (multiple || (!multiple && value?.length === 0))">{{ placeholder }}</p>

      <ion-input
        mode="ios"
        #searchField
        *ngIf="(multiple || (!multiple && value?.length === 0) || (addTag && value?.length === 0)) && !hideInput"
        [disabled]="disabled"
        [(ngModel)]="searchString"
        (click)="service.noBubble($event); presentPopover()"
        (ngModelChange)="filterDisplayItems(); this.searchTermChange.emit(this.searchString);"
      ></ion-input>
    </div>
  </div>

  <div class="actions">
    <ion-button
      fill="clear"
      size="small"
      *ngIf="clearable && value?.length > 0 && !disabled"
      (click)="service.noBubble($event); clearAll()"
    >
      <tr-icon class="tr-icon" [icon]="icon.cancel"></tr-icon>
    </ion-button>

    <ion-button fill="clear" size="small" (click)="service.noBubble($event); presentPopover()">
      <tr-icon class="tr-icon arrow-down-icon" [icon]="icon.arrowDown" [size]="iconSize.small"></tr-icon>
    </ion-button>
  </div>
</section>

<ion-modal
  id="dropdown-modal-{{elementId}}"
  class="popover-modal"
  [keyboardClose]="false"
  [isOpen]="isPopoverOpen"
  [showBackdrop]="false"
  [animated]="false"
  (didDismiss)="isPopoverOpen = false; popoverClose.emit()"
  (willDismiss)="unfocusSearchInput()"
  (willPresent)="calculatePositionInternalSync()"
  (click)="clickOutside()"
>
  <ng-template>
    <div
      #modalContent
      class="popover-modal-content border-border background-background"
      [style.left.px]="popoverLeft"
      [style.top.px]="popoverTop"
      [style.width.px]="popoverWidth"
      [class.no-top-pos]="popoverTop === 0"
      [class.inverted]="popoverInverted"
      (click)="service.noBubble($event)"
    >
      <div
        class="drop-message click"
        *ngIf="addTag && searchString?.length > 0"
        (click)="addNewItem()"
      >
        <ng-container *ngIf="(maxSelectedItems && maxSelectedItems > value.length) || !maxSelectedItems; else maxSelectTemp">
          <p *ngIf="showAddTagOnlyIfNoResults ? displayItems.length === 0 : true">
            <span>Add item </span>"{{ searchField?.value }}"
          </p>
        </ng-container>
      </div>

      <div class="drop-message" *ngIf="(!items || items.length === 0) && searchString?.length === 0">
        <p>{{ noItemsText }}</p>
      </div>

      <div class="drop-message" *ngIf="displayItems?.length === 0 && !addTag && searchString?.length > 0">
        <p>No items found</p>
      </div>

      <ion-list lines="full" mode="ios">
        <div #listContent class="list-wrapper" [style.max-height]="maxListHeight" [style.min-width]="minWidth">
          <ion-item
            [class.readonly]="disabled || item.disabled"
            id="display-item-{{item[bindValue]}}"
            *ngFor="let item of displayItems"
            (click)="selectSingleItem(item[bindValue])"
            class="ion-focusable ion-activatable"
          >
            <frontend-tooltip
              parentId="display-item-{{item[bindValue]}}"
              *ngIf="optionWrapper.offsetWidth < optionBody.offsetWidth"
              [text]="itemsIdToLabelMap[item[bindValue]]"
            ></frontend-tooltip>

            <ion-checkbox
              *ngIf="multiple"
              justify="start"
              mode="md"
              [checked]="itemsIdToStateMap[item[bindValue]]"
              [disabled]="false"
              (ionChange)="checkboxChange(item[bindValue], $event.detail)"
            ></ion-checkbox>

            <div *ngIf="!multiple" class="hidden-checkbox"></div>

            <div class="option-wrapper" #optionWrapper [style.min-height.px]="optionBody.offsetHeight">
              <div #optionBody class="new-dropdown-option-text" [innerHTML]="itemsIdToLabelMap[item[bindValue]]"></div>
            </div>

            <div class="option-divider background-border"></div>
          </ion-item>
        </div>
      </ion-list>
    </div>
  </ng-template>
</ion-modal>

<ng-template #maxSelectTemp>
  <p><span>Maximum amount of items already selected. <b>Clear</b></span></p>
</ng-template>
